import { render, staticRenderFns } from "./LessonItemDesktop.vue?vue&type=template&id=b6945282&scoped=true"
import script from "./LessonItemDesktop.vue?vue&type=script&lang=js"
export * from "./LessonItemDesktop.vue?vue&type=script&lang=js"
import style0 from "./LessonItemDesktop.vue?vue&type=style&index=0&id=b6945282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6945282",
  null
  
)

export default component.exports